import _ from 'lodash'

class SubscriptionRecord {
  constructor(data) {
    this.activatedAt = data.activatedAt,
    this.canceledAt = data.canceledAt,
    this.expiresAt = data.expiresAt,
    this.plan = data.plan,
    this.state = data.state,
    this.subscriptionAddOns = data.subscriptionAddOns,
    this.taxInCents = data.taxInCents,
    this.unitAmountInCents = data.unitAmountInCents,
    this.uuid = data.uuid
  }

  get prettyAddOns() {
    return _(this.subscriptionAddOns)
      .map('addOnCode')
      .toString()
  }
}

export default SubscriptionRecord
